const BASE_API = process.env.REACT_APP_ROUTE_API;
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
    save: async (data) => {
      try {
        let req;
        if (data.id) {
          req = await fetch(`${BASE_API}site/aluno-temp/` + data.id , {
            method: 'POST',//Todo verificar cors 403 put
            headers: headers,
            body: JSON.stringify(data) 
          });
        } else {
          req = await fetch(`${BASE_API}site/aluno-temp`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data) 
          });
        }
        
        const json = await req.json();
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return error;
      }
    },
    obterPorCpf: async (cpf) => {
      try {
        const req = await fetch(`${BASE_API}site/obter-aluno-temp/${cpf}`, {
          method: 'GET',
          headers: headers
        });
        const json = await req.json();
              json.data = json.data ?? [];
              json.statusRetorno = req.status;
        return json;
      } catch (error) {
        return(error);
      }
    },
};